import React from "react";
import "../../App.css"; // Import Tailwind styles
import image1 from "../logo/soyabean.jpg";
import image3 from "../logo/coffee.jpg";
import image4 from "../logo/Firefly linseeds and sesame seeds in a bag against the background of burlap 35981.jpg";
import image5 from "../logo/spices.jpg";
import imagee from "../logo/sunflowerOil.jpg";
import imageee from "../logo/mas.jpg";
import imageNo1 from "../logo/commm.jpg";
import imageNo2 from "../logo/tafo.jpg";
import imageNo3 from "../logo/vaccine.jpg";
import imageNo4 from "../logo/palmoil.jpg";
import imageNo5 from "../logo/pulses-getty.webp";
import image7 from "../logo/animal antibiotics.jpg";
import image8 from "../logo/vitansSup.jpg";
import he from "../logo/web.jpg";

function OurProducts() {
  return (
    <div className="font-sans mt-44">
      {/* Hero Section with Parallax Effect */}
      <section id="home" className="relative text-center py-48 overflow-hidden">
        {/* Hero Image with Parallax Effect */}
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${he})`,
            backgroundAttachment: "fixed", // Parallax effect
          }}
        />

        {/* Dark Overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30"></div>

        {/* Hero Content */}
        <div
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-8 py-5 max-w-xl rounded-lg shadow-lg text-center bg-white bg-opacity-40 backdrop-blur-md border border-white border-opacity-20 hover:bg-opacity-30 hover:shadow-md transition duration-300"
          style={{ height: "auto", maxHeight: "700px" }}
        >
          <h1 className="text-2xl md:text-3xl font-bold text-green-800 leading-tight mb-2 mt-5">
            Our Products
          </h1>
          <p className="text-gray-200 mb-4 text-lg md:text-xl">
            Explore our diverse range of high-quality products that cater to your needs.
          </p>

          {/* Buttons Inside the Transparent Container */}
          <div className="flex justify-center gap-4 mb-5">
            {/* <a
              href="/about-us"
              className="bg-green-600 text-white py-2 px-4 mt-4 rounded hover:bg-green-700 transition inline-block"
            >
              Learn More
            </a> */}
          </div>
        </div>
      </section>

      {/* Edible Oil Section */}
      <Section
        id="edible-oil"
        title="Edible Oil"
        description="Our edible oils are processed with care to ensure the highest quality and nutritional value."
        items={[
          {
            name: "Sunflower Oil",
            description: "Rich in Vitamin E and ideal for healthy cooking.",
            image: imagee,
          },
          {
            name: "Palm Oil",
            description: "Perfect for frying with a high smoke point.",
            image: imageNo4,
          },
          {
            name: "Soybean Oil",
            description: "A versatile oil for everyday cooking and baking.",
            image: image1,
          },
        ]}
      />

      {/* Wezam (Coffee) Section */}
      <Section
        id="wezam"
        title="Wezam (Coffee)"
        description="Experience the rich aroma and exceptional taste of our premium coffee."
        items={[
          {
            name: "Arabica Coffee",
            description:
              "Delicately flavored and sourced from high-altitude farms.",
            image: image3,
          },
        ]}
      />

      {/* Zala Section */}
      <Section
        id="zala"
        title="Zala (Oil Seeds, Pulses & Spices)"
        description="We supply premium oil seeds, pulses, and spices to meet your culinary and nutritional needs."
        items={[
          {
            name: "Oil Seeds",
            description: "Rich in healthy fats and antioxidants.",
            image: image4,
          },
          {
            name: "Pulses",
            description: "A protein-packed pulse for various dishes.",
            image: imageNo5,
          },
          {
            name: "Spices",
            description: "A spice known for its flavor and health benefits.",
            image: image5,
          },
        ]}
      />

      {/* Animal Health Medicines Section */}
      <Section
        id="animal-health"
        title="Animal Health Medicines"
        description="Ensuring the well-being of animals with our trusted veterinary medicines."
        items={[
          {
            name: "Antibiotics",
            description: "Effective solutions to treat animal infections.",
            image: image7,
          },
          {
            name: "Vitamins & Supplements",
            description: "Boost animal health and productivity.",
            image: image8,
          },
          {
            name: "Vaccines",
            description: "Prevention is better than cure with our reliable vaccines.",
            image: imageNo3,
          },
        ]}
      />
    </div>
  );
}

// Section Component
function Section({ id, title, description, items }) {
  return (
    <section id={id} className="py-16 bg-white">
      <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-green-700 mb-4">{title}</h2>
        <p className="text-gray-600 mb-8">{description}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 border rounded-lg p-6 shadow-md hover:shadow-lg transition"
            >
              <img
                src={item.image}
                alt={`Image of ${item.name}`}
                className="w-full h-40 object-cover rounded-lg mb-4 transition-transform duration-300 hover:scale-105 hover:shadow-lg"
                loading="lazy"
              />
              <h3 className="text-xl font-semibold text-gray-800">{item.name}</h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurProducts;

